import React from 'react';

import { Placement } from '@blueprintjs/popover2';

// eslint-disable-next-line no-restricted-imports
import MessageTooltip from 'components/MessageTooltip/MessageTooltip';

import block from 'utils/bem-css-modules';

import style from './MultiLineEllipsisText.module.pcss';
import { useEllipsisTooltip } from './useEllipsisTooltip';

const b = block(style);

interface MultiLineEllipsisTextProps {
  text: string;
  className?: string;
  placement?: Placement;
  maxLineCount: number;
}

const MultiLineEllipsisText: React.FC<MultiLineEllipsisTextProps> = ({
  text,
  maxLineCount,
  className,
  placement = 'top'
}) => {
  const { textElementRef, isTooltipEnabled } = useEllipsisTooltip(true);

  const classNameString = className ? ` ${className}` : '';

  return (
    <MessageTooltip
      content={text}
      target={
        <div
          ref={textElementRef}
          className={b('textContainer')}
          style={{
            WebkitLineClamp: maxLineCount
          }}
          data-testid="text-container"
        >
          {text}
        </div>
      }
      placement={placement}
      className={`${b()}${classNameString}`}
      disabled={!isTooltipEnabled}
    />
  );
};

export default React.memo(MultiLineEllipsisText);
